"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REACT_FLOW_CHART = 'react-flow-chart';
//# sourceMappingURL=constants.js.map